import { BannerImageContainer } from "./styles";
import Circle from "assets/images/circle.svg";
import FirstPhone from "assets/images/iphone_16_pro_1.svg";
import SecondPhone from "assets/images/iphone_16_pro_2.svg";

const DataredeDriverImage = () => {
  return (
    <BannerImageContainer>
      <img className="datarede-driver" src={Circle} />
      <img className="phone left" src={FirstPhone} />
      <img className="phone right" src={SecondPhone} />
    </BannerImageContainer>
  );
};

export default DataredeDriverImage;
